export const safePushToDL = event => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(event)
  } else {
    console.log('GTM not initialized properly')
  }
}